<template>
  <v-toolbar flat style="background-color: #FAFAFA">
    <v-toolbar-title>
      <h2>Reporting</h2>
    </v-toolbar-title>

    <v-spacer></v-spacer>
    <app-timeselector
      @datesUpdate="datesUpdate"
     />
  </v-toolbar>
</template>

<script>
  import Timeselector from './Timeselector.vue'
  export default {
    components: {
      AppTimeselector : Timeselector
    },
    methods: {
      datesUpdate(dates){
        this.$emit('datesUpdate',dates)
      }
    }
  }
</script>